import { Controller } from "@hotwired/stimulus"
import FileUploadProgress from "../../components/file_upload_progress"

export default class extends Controller {
  connect() {
    this.form = this.element
    this.form.addEventListener('submit', this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    event.preventDefault()

    // Create and initialize progress bar
    const progressBar = new FileUploadProgress()
    progressBar.init()

    // Submit the form
    this.form.submit()
  }
}
